__turbopack_context__.v({
  "block": "Skeleton-module-scss-module__c22RLW__block",
  "shimmer": "Skeleton-module-scss-module__c22RLW__shimmer",
  "skeleton": "Skeleton-module-scss-module__c22RLW__skeleton",
});
